<nz-spin [nzSpinning]="isLoading">
  <div class="loginBackground" style="padding-top:8px;">
    <!--第一行-->
    <div nz-row>
      <div nz-col nzSpan="16" nzPush="4">
        <div class="logLImg">
          <span style="color:  rgb(161, 204, 86);margin-right: -15px;">
            {{"M"}}
          </span><span nz-col>
            {{"RO"}}
          </span><span style="color: rgb(161, 204, 86);margin-right: -15px;">
            {{"V"}}</span><span nz-col>
            {{"endor"}}</span><span style="color: rgb(161, 204, 86);margin-right: -15px;">
            {{"M"}}</span><span nz-col>
            {{"anagement"}}</span>
        </div>
      </div>
      <div nz-col nzPush="6" style="font-size: 3.07vw;">
        <span style="font-size: 25px; color: rgb(231, 239, 243); cursor: pointer;" nz-icon nzType="setting"
          nzTheme="fill" nz-dropdown nzTrigger="click" [nzDropdownMenu]="menu" nzPlacement="bottomCenter">
          <div style="display: inline-block; padding-right: 12px; cursor: pointer;">{{"homepagesetting" | translate}}
          </div>
        </span>

        <nz-dropdown-menu style="width: 240px;" #menu="nzDropdownMenu">
          <ul nz-menu style="text-align:left;">
            <li nz-menu-item (click)="shoumodal()" style="width: 120px;height: 40px;">{{"window" |translate }}
              <nz-modal [(nzVisible)]="isVisiblewindow" nzTitle='{{"window"|translate}}'
                (nzOnCancel)="handleCancelwindow()" nzCancelText='{{"cancel"|translate}}' nzOkText='{{"Ok"|translate}}'
                (nzOnOk)="handleOkwindow()" nzMaskClosable="false" [nzFooter]="null">
                <ng-container *nzModalContent>
                  <div class="modal2">
                    <nz-table nzNoResult=" ">
                      <thead>
                        <tr>
                          <th scope="col" nzWidth="80px" style="text-align: center; font-size: 30px;">{{ "Site" |
                            translate}}
                          </th>
                          <th scope="col" nzWidth="100px" style="text-align: center; font-size: 30px;">{{
                            "ContactWindow"
                            |translate}}</th>
                          <th scope="col" nzWidth="80px" style="text-align: center; font-size: 30px;">{{
                            "extensionnumber"
                            | translate}}
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td style="text-align: center;font-size: 20px;">WCA</td>
                          <td style="text-align: center;font-size: 20px;">Kurt Chen</td>
                          <td style="text-align: center;font-size: 20px;">+8500-27571</td>
                        </tr>
                        <tr>
                          <td style="text-align: center;font-size: 20px;">WCD</td>
                          <td style="text-align: center;font-size: 20px;">Fang Liu</td>
                          <td style="text-align: center;font-size: 20px;">+8551-1878</td>
                        </tr>
                        <tr>
                          <td style="text-align: center;font-size: 20px;">WCHQ</td>
                          <td style="text-align: center;font-size: 20px;">Kurt Chen</td>
                          <td style="text-align: center;font-size: 20px;">+8500-27571</td>
                        </tr>
                        <tr>
                          <td style="text-align: center;font-size: 20px;">WCQ</td>
                          <td style="text-align: center;font-size: 20px;">Frank Liang</td>
                          <td style="text-align: center;font-size: 20px;">+8550-2967</td>
                        </tr>
                        <tr>
                          <td style="text-align: center;font-size: 20px;">WHQ</td>
                          <td style="text-align: center;font-size: 20px;">Kurt Chen</td>
                          <td style="text-align: center;font-size: 20px;">+8500-27571</td>
                        </tr>
                        <tr>
                          <td style="text-align: center;font-size: 20px;">WIH</td>
                          <td style="text-align: center;font-size: 20px;">Grace IH Chen</td>
                          <td style="text-align: center;font-size: 20px;">+8500-32071</td>
                        </tr>
                        <tr>
                          <td style="text-align: center;font-size: 20px;">WKS</td>
                          <td style="text-align: center;font-size: 20px;">Yuxi Wu</td>
                          <td style="text-align: center;font-size: 20px;">+8568-6357</td>
                        </tr>
                        <tr>
                          <td style="text-align: center;font-size: 20px;">WKH</td>
                          <td style="text-align: center;font-size: 20px;">Kurt Chen</td>
                          <td style="text-align: center;font-size: 20px;">+8500-27571</td>
                        </tr>
                        <tr>
                          <td style="text-align: center;font-size: 20px;">WMT</td>
                          <td style="text-align: center;font-size: 20px;">Kurt Chen</td>
                          <td style="text-align: center;font-size: 20px;">+8500-27571</td>
                        </tr>
                        <tr>
                          <td style="text-align: center;font-size: 20px;">WZS</td>
                          <td style="text-align: center;font-size: 20px;">Nance Chen</td>
                          <td style="text-align: center;font-size: 20px;">+8560-6984</td>
                        </tr>
                        <tr>
                          <td style="text-align: center;font-size: 20px;">XTRKS</td>
                          <td style="text-align: center;font-size: 20px;">Yuxi Wu</td>
                          <td style="text-align: center;font-size: 20px;">+8568-6357</td>
                        </tr>
                        <tr>
                          <td style="text-align: center;font-size: 20px;">WMX</td>
                          <td style="text-align: center;font-size: 20px;">Joaquin Diaz</td>
                          <td style="text-align: center;font-size: 20px;"></td>
                        </tr>
                      </tbody>
                    </nz-table>
                  </div>
                  <button nz-button (click)="handleCancelwindow()" nzType="primary" class="default-button;"
                    style="margin-left: 370px;">{{"Ok" |translate }}</button>
                </ng-container>
              </nz-modal>
            </li>
          </ul>
          <ul nz-menu style="text-align:left;">
            <li nz-submenu nzTitle='{{"Language"|translate}}'>
              <ul *ngFor="let language of languageItems;let i = index">
                <li nz-menu-item (click)="switLanguage(language.value)">
                  {{language.lable}}</li>
              </ul>
            </li>
          </ul>

        </nz-dropdown-menu>
      </div>
    </div>
    <!--第二行-->
    <div nz-row style="margin-top: 65.5vh;">
      <div nz-col nzSpan="15" nzPush="1">
        <span style="font-size: 25px; color:rgb(2, 98, 143);">{{"Announcement" | translate}}</span>

        <div nz-col *ngIf="langueBooleanCN">
          <div class="Rules2">
            <nz-collapse nzGhost>
              <nz-collapse-panel *ngFor="let panel of listtimedata" [nzHeader]="'- ' + panel.noticeTitle"
                nzActive="false" class="collapse" [nzShowArrow]="false" (click)="showModal(panel)">
              </nz-collapse-panel>
            </nz-collapse>
          </div>
        </div>

        <div nz-col *ngIf="langueBooleanTW">
          <div class="Rules2">
            <nz-collapse nzGhost>
              <nz-collapse-panel *ngFor="let panel of listtimedata" [nzHeader]="'- ' + panel.twNoticeTitle"
                nzActive="false" class="collapse" [nzShowArrow]="false" (click)="showModal(panel)" nzAccordion="true">
              </nz-collapse-panel>
            </nz-collapse>
          </div>
        </div>

        <div nz-col *ngIf="langueBooleanEN">
          <div class="Rules2">
            <nz-collapse nzGhost>
              <nz-collapse-panel *ngFor="let panel of listtimedata" [nzHeader]="'- ' + panel.enNoticeTitle"
                nzActive="false" class="collapse" [nzShowArrow]="false" (click)="showModal(panel)">
              </nz-collapse-panel>
            </nz-collapse>
          </div>
        </div>
        <div nz-col *ngIf="langueBooleanVN">
          <div class="Rules2">
            <nz-collapse nzGhost>
              <nz-collapse-panel *ngFor="let panel of listtimedata" [nzHeader]="'- ' + panel.vnNoticeTitle"
                nzActive="false" class="collapse" [nzShowArrow]="false" (click)="showModal(panel)">
              </nz-collapse-panel>
            </nz-collapse>
          </div>
        </div>
        <!-- <strong>备案号:</strong>
      <a href="https://beian.miit.gov.cn/" style="color: black;">粤ICP备10004982号</a> -->
      </div>

      <div nz-col nzPush="5" style="margin-top: 100px;">
        <button class="login_btn" (click)="loginEvent()"> {{ "idmlogin" | translate }}</button>
      </div>
    </div>
  </div>
</nz-spin>


<nz-modal [(nzVisible)]="isVisible" nzTitle='{{"Announcement"|translate}}' (nzOnCancel)="handleCancel1()"
  (nzOnOk)="handleOk1()" nzCancelText='{{"cancel"|translate}}' nzOkText='{{"Ok"|translate}}' nzMaskClosable="false"
  [nzFooter]="null">
  <ng-container *nzModalContent>
    <div class="modal">
      <div *ngIf="langueBooleanCN">
        <nz-card *ngFor="let panel of listtimedata">
          <p style="font-size:25px;color: rgb(2, 98, 143);"> -{{panel.noticeTitle}}</p>
          <p style="font-size:20px;color: black;margin-left: 30px;">{{panel.chNoticeDetail}}</p>
        </nz-card>
      </div>
      <div *ngIf="langueBooleanTW">
        <nz-card *ngFor="let panel of listtimedata">
          <p style="font-size:25px;color: rgb(2, 98, 143);"> -{{panel.twNoticeTitle}}</p>
          <p style="font-size:20px;color: black;margin-left: 30px;">{{panel.twNoticeDetail}}</p>
        </nz-card>
      </div>
      <div *ngIf="langueBooleanEN">
        <nz-card *ngFor="let panel of listtimedata">
          <p style="font-size:25px;color: rgb(2, 98, 143);"> -{{panel.enNoticeTitle}}</p>
          <p style="font-size:20px;color: black;margin-left: 30px;">{{panel.enNoticeDetail}}</p>
        </nz-card>
      </div>
      <div *ngIf="langueBooleanVN">
        <nz-card *ngFor="let panel of listtimedata">
          <p style="font-size:25px;color: rgb(2, 98, 143);"> -{{panel.vnNoticeTitle}}</p>
          <p style="font-size:20px;color: black;margin-left: 30px;">{{panel.vnNoticeDetail}}</p>
        </nz-card>
      </div>
    </div>

    <ng-template #extraTemplate>
    </ng-template>
    <button nz-button (click)="handleCancel1()" nzType="primary" class="default-button;"
      style="margin-left: 370px;">{{"Ok" |translate }}</button>
  </ng-container>
</nz-modal>